import React from 'react';
import classes from './BlogPost.module.scss';
import {Link} from "../link/Link";
import PropTypes from "prop-types";

export const BlogPost = ({image, title, subtitle, link}) => {
    return (
        <div className={`${classes['wrapper']}`}>
            <img className={`${classes['image']}`} src={image} alt="random"/>
            <div className={`${classes['title']}`}>
                {title}
            </div>
            <div className={`${classes['subtitle']}`}>
                {subtitle.truncate(80)}
                <span className={`${classes['link']}`}>
                    <Link to={link} inherit>
                         {' Continue Reading'}
                    </Link>
                </span>
            </div>
        </div>
    );
};

BlogPost.propTypes = {
    /**
     * blog post image link
     */
    image: PropTypes.string.isRequired,
    /**
     * Title of the post
     */
    title: PropTypes.string.isRequired,
    /**
     * Subtitle of the post
     */
    subtitle: PropTypes.string.isRequired,
    /**
     * Link of the post for "read more" section
     */
    link: PropTypes.string.isRequired
}

BlogPost.defaultProps = {
    image: undefined,
    title: undefined,
    subtitle: undefined,
    link: ''
}